import { DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/ja_JP';
import { Rule } from 'antd/es/form';
import { Form } from 'antd/lib';
import React from 'react';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import getMessage from 'utilities/constants/MESSAGE';

import CalendarEventFill from 'assets/icons/calendar2-event-fill.svg';

export interface DatePickerProps {
    dropdownClassName?: string;
    dropdownAlign?: any;
    popupStyle?: React.CSSProperties;
    transitionName?: string;
    placeholder?: string;
    allowClear?:
        | boolean
        | {
              clearIcon?: React.ReactNode;
          };
    autoFocus?: boolean;
    disabled?: boolean;
    tabIndex?: number;
    open?: boolean;
    defaultOpen?: boolean;
    /** Make input readOnly to avoid popup keyboard in mobile */
    inputReadOnly?: boolean;
    id?: string;
    presets?: any[];
    format?: any;
    suffixIcon?: React.ReactNode;
    /**
     * Clear all icon
     * @deprecated Please use `allowClear` instead
     **/
    clearIcon?: React.ReactNode;
    prevIcon?: React.ReactNode;
    nextIcon?: React.ReactNode;
    superPrevIcon?: React.ReactNode;
    superNextIcon?: React.ReactNode;
    getPopupContainer?: (node: HTMLElement) => HTMLElement;
    panelRender?: (originPanel: React.ReactNode) => React.ReactNode;
    inputRender?: (props: React.InputHTMLAttributes<HTMLInputElement>) => React.ReactNode;
    onChange?:  () => void;
    onOpenChange?: (open: boolean) => void;
    onFocus?: () => void;
    onBlur?:  () => void;
    onMouseDown?:  () => void;
    onMouseUp?:  () => void;
    onMouseEnter?:  () => void;
    onMouseLeave?:  () => void;
    onClick?:  () => void;
    onContextMenu?:  () => void;
    onKeyDown?:  () => void;
    /**
     * Trigger `onChange` event when blur.
     * If you don't want to user click `confirm` to trigger change, can use this.
     */
    changeOnBlur?: boolean;
    /** @private Internal usage, do not use in production mode!!! */
    pickerRef?: any;
    role?: string;
    name?: string;
    autoComplete?: string;
    direction?: 'ltr' | 'rtl';
    labelClassName?: string;
    rules?: Rule[];
    required?: boolean;
    label?: string;
    className?: string;
    disabledDate?: (current: any) => boolean;
}

export const FormDatePicker = ({
    labelClassName = '',
    name,
    rules = [],
    required,
    label,
    ...props
}: DatePickerProps) => {
    const [isRequire, setIsRequire] = React.useState<boolean>(required ?? false);
    const [validateRules, setValidateRules] = React.useState<Rule[]>([]);

    const checkRuleRequire = (rules: Rule[]) => {
        let isRequire = false;
        rules.forEach((rule: any) => {
            if (rule.required) {
                isRequire = true;
            }
        });
        return isRequire;
    };

    React.useEffect(() => {
        const tempRule = rules;
        const ruleRequire = checkRuleRequire(rules);
        if (ruleRequire) {
            setIsRequire(true);
        } else if (required) {
            tempRule.push(() => ({
                required: true,
                message: getMessage('In_Required', label),
            }));
            setIsRequire(true);
        } else {
            setIsRequire(false);
        }
        setValidateRules(tempRule);
    }, [required]);

    return (
        <>
            <span className={labelClassName}>
                {label}
                {label && isRequire && <span style={{ color: '#EB5757' }}>*</span>}
            </span>
            <Form.Item name={name} rules={validateRules} className={props.className}>
                <DatePicker
                    format={DATE_FORMAT.FORMAT1}
                    {...props}
                    getPopupContainer={(trigger: any) => trigger.parentNode}
                    inputReadOnly
                    locale={locale}
                    suffixIcon={<img alt="" src={CalendarEventFill} />}
                    autoComplete="off"
                    style={{ width: '100%' }}
                    onFocus={props.onFocus as React.FocusEventHandler<HTMLElement>}
                    onBlur={props.onBlur as React.FocusEventHandler<HTMLElement>}
                    onKeyDown={props.onKeyDown as (event: React.KeyboardEvent<HTMLElement>, preventDefault: () => void) => void}
                    onChange={(date, dateString) => {
                        if (props.onChange && typeof dateString === 'string') {
                            props.onChange();
                        }
                    }} 
                />
            </Form.Item>
        </>
    );
};
